
import { Component, Vue, Ref } from 'vue-property-decorator'
import { PersonService } from '@/services'
import { AppModule } from '@/store/modules/app'
import { ElForm } from 'element-ui/types/form'
import AvatarUpload, { AvatarUploadIns } from '@/components/avatar_upload/index.vue'
import DynamicTags, { ins } from '@/components/dynamic_tags/index.vue'
import UploadImg from '@/common/class/UploadImg'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

type tagKey = 'keywords' | 'bKeywords' | 'stopwords'

// 创建行业id
const createIndustryId = (id: number) => {
    if (id == null) return []
    return [ +String(id).substr(0, 2), +String(id).substr(0, 4), id ]
}

const peopleTypes = [
    { value: 0, name: '其他' },
    { value: 1, name: '上市公司董事长' },
    { value: 2, name: '其他公司高管' },
    { value: 3, name: '专家\\学者\\学家\\教授' },
    { value: 4, name: '上市公司董秘' },
    { value: 5, name: '政府人士' },
    { value: 6, name: 'NGO人士' },
    { value: 7, name: '明星' },
    { value: 8, name: '艺术大咖' },
    { value: 9, name: '网红' }
]

@Component({
    name: 'person-detail',
    components: {
        RowWrap,
        RowItem,
        AvatarUpload,
        DynamicTags
    }
})
export default class extends Vue {
    private personId = ''
    private person: any = { 
        avatar: '', 
        name: '', 
        label: '', 
        link: [],
        type_id: '',
        staff: '',
        status: ''
    }
    private rules = {
        name: { required: true, message: '名字为必填项' },
        label: { required: true, message: '头衔为必填项' }
    }
    private keywords: string[] = []
    private stopwords: string[] = []
    private bKeywords: string[] = []
    private isUpdateLoading = false
    private peopleTypes = peopleTypes
    @Ref('personForm') private formEl!: ElForm
    @Ref('keywordRef') private keywordEl!: ins
    @Ref('stopwordRef') private stopwordEl!: ins
    @Ref('bkeywordRef') private bkeywordEl!: ins
    @Ref('avatarRef') private avatarEl!: AvatarUploadIns

    get types() {
        return AppModule.filterTypes
    }

    get industryList() {
        return AppModule.industry
    }

    created() {
        this.$title(`Loading | ${this.$route.meta.title} - 庖丁`)
        this.personId = this.$route.params.id
    }

    async mounted() {
        this.getPersonDetail()
        AppModule.getTypes()
        AppModule.getIndustry()
    }

    /** 解析后端返回的字符串数组字段 */
    private parseArrayField(value: any): string[] {
        if (Array.isArray(value)) return value
        if (typeof value === 'string' && value) {
            try {
                const parsed = JSON.parse(value)
                return Array.isArray(parsed) ? parsed : []
            } catch (e) {
                return value.split(',')
            }
        }
        return []
    }

    /** 获取人物详情 */
    private async getPersonDetail() {
        const params = {
            id: +this.personId
        }
        const result = await PersonService.getPersonDetail(params)
        if (result.status === 200) {
            const { link, post, type, b_keywords, keywords, stopwords } = result.data
            result.data.link = this.parseArrayField(link).map((url: string, index: number) => ({ key: index, value: url }))
            result.data.type_id = type ? createIndustryId(type.id).pop() : ''
            this.person = result.data
            this.person.status = result.data.status.id
            this.$set(this.person, 'staff', this.parseArrayField(post).join('、'))
            this.bKeywords = this.parseArrayField(b_keywords)
            this.keywords = this.parseArrayField(keywords)
            this.stopwords = this.parseArrayField(stopwords)
            this.$title(`${this.person.name} | ${this.$route.meta.title} - 庖丁`)
        }
    }

    /** 更新人物详情 */
    private async updatePersonDetail(params: any) {
        params = { id: this.personId, ...params }
        const result = await PersonService.updatePersonInfo(params)
        if (result.status === 200) {
            return this.$msuccess('修改成功')
        }
        return this.$merror(result.message || '发生错误, 请稍后再试')
    }

    /** 删除关键字或标签 */
    handleClose(item: string, key: tagKey) {
        const list = this[key]
        list.splice(list.indexOf(item), 1)
    }

    // 新增自媒体链接
    onAddUrl() {
        this.person.link.push({ key: +new Date, value: '' })
    }
    // 删除媒体链接
    onDeleteUrl(url: any) {
        const { link } = this.person
        link.splice(link.indexOf(url), 1)
    }

    // 修改
    onUpdate() {
        this.formEl.validate(async (isValid: boolean) => {
            if (!isValid) return
            this.showLoading()
            let result: any = ''
            const keywords = this.keywordEl.getTags()
            const stopwords = this.stopwordEl.getTags()
            const bkeywords = this.bkeywordEl.getTags()
            const imgFile = this.avatarEl.getFile()
            // 上传图片
            if (typeof imgFile === 'object') {
                result = await new UploadImg(imgFile).upload()
                if (result.error) {
                    this.$message({ type: 'warning', message: '图片上传失败, 请稍后再试' })
                    return false
                }
                result = result.key
            }
            result = result || this.person.avatar || undefined
            const link = this.person.link.map((url: any) => url.value)
            let typeId
            if (Array.isArray(this.person.type_id)) {
                typeId = this.person.type_id.pop()
            } else if (this.person.type_id) {
                typeId = this.person.type_id
            }
            const params = {
                link,
                name: this.person.name,
                avatar: result,
                label: this.person.label,
                type_id: typeId,
                nationality: this.person.nationality,
                university: this.person.university,
                birthday: this.person.birthday,
                post: this.person.staff.split('、'),
                intro: this.person.intro,
                keywords: keywords,
                b_keywords: bkeywords,
                stopwords: stopwords,
                status: this.person.status
            }
            await this.updatePersonDetail(params)
            this.hideLoading()
        })
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }
}
